export const passwordCardDeleteModal = {
	confirmButton: "Sí, deseo bloquear la tarjeta de contraseñas",
	text:
		"En caso de pérdida de una tarjeta de contraseñas, es aconsejable bloquearla. Al confirmar el bloqueo, su historial queda registrado, pero deja de ser válida. Siendo así, ¿desea bloquear ",
	complement: {
		single: "la tarjeta de contraseñas de {{cardName}}?",
		multiple: "las tarjetas de contraseñas seleccionadas?",
	},
};
